import React from "react";
import {getEvents} from "../../Helpers/EventHelper";
import sharedEvents from "../constants/EmbeddedEvents";
import withErrorReporting from "../../General/components/ErrorReporting/withErrorReporting";

/**
 * This HOC attaches the embeddedEvents prop to the wrapped App component and includes
 * the relevant methods.
 * @method postEvent posts a message event to the parent window that launched the iframe
 * @param WrappedComponent
 * @returns WithEmbeddedEvents
 */
export default function withEmbeddedEvents(WrappedComponent) {
    class WithEmbeddedEvents extends React.Component {
        postEvent = (name, data) => {
            const isEmbedded = window.parent !== window;
            if (!isEmbedded) return;

            try {
                window.parent.postMessage({name, data}, document.referrer || "*");
            } catch (error) {
                this.props.errorReporting.reportError(error);
                console.log(error);
            }
        };

        render() {
            return (
                <WrappedComponent
                    embeddedEvents={getEvents(this.postEvent, sharedEvents)}
                    {...this.props}
                />
            );
        }
    }

    return withErrorReporting(WithEmbeddedEvents);
}
